import { render, staticRenderFns } from "./answerQuestionSparticipationRecord.vue?vue&type=template&id=a2d949de&scoped=true"
import script from "./answerQuestionSparticipationRecord.vue?vue&type=script&lang=js"
export * from "./answerQuestionSparticipationRecord.vue?vue&type=script&lang=js"
import style0 from "./answerQuestionSparticipationRecord.vue?vue&type=style&index=0&id=a2d949de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d949de",
  null
  
)

export default component.exports